<div fxLayout="row" fxLayoutGap="0px" fxLayoutAlign="start center">
  <div>
    <a [routerLink]="route" nz-button nzType="default" nzShape="circle">
      <span nz-icon nzType="arrow-left"></span>
    </a>
  </div>

  <a [routerLink]="route" mat-button><ng-content></ng-content></a>
</div>
